import axios from 'axios'

export const siscomex = axios.create({
  baseURL: 'http://localhost:5000'
});